import { useContext, useEffect } from 'react';
import { load, save, remove } from 'react-cookies';
import { useTranslation } from 'react-i18next';

import { NotificationContext, UserContext } from 'contexts';
import { ClientUserProfile, PartnerUserProfile } from 'api/users.types';

const STORAGE_KEY = '__storage_limit__';

export const StorageNotification = () => {
  const { t } = useTranslation();
  const { notification } = useContext(NotificationContext);
  const {
    data: userData,
    role: { isClient, isPartner }
  } = useContext(UserContext);

  useEffect(() => {
    // Use userData from UserContext instead of making additional API calls
    if (!userData || (!isClient && !isPartner)) {
      return;
    }

    const data = userData as ClientUserProfile | PartnerUserProfile;
    
    // Check if the user data has storage_sum and storage_limit properties
    if (!('storage_sum' in data) || !('storage_limit' in data)) {
      return;
    }

    const percent = 100 * (data.storage_sum / data.storage_limit);

    if (percent < 80) {
      remove(STORAGE_KEY, { path: '/' });
      return;
    }

    !load(STORAGE_KEY) &&
      notification.info({
        message: t('storageLimitAlert'),
        placement: 'bottom',
        duration: null,
        onClose: () => save(STORAGE_KEY, 'true', { path: '/' })
      });

    return () => notification.destroy();
  }, [userData, isClient, isPartner, notification, t]);

  return null;
};
